/**
 * Product card component
 *
 * @module product-card
 * @version 1.0.0
 * @extends HTMLElement
 */

customElements.component = 'product-card';

if(!customElements.get(customElements.component)) {

    class productCard extends HTMLElement {

        /**
         * Web component constructor
         *
         * @constructor
         */
        constructor() {

            super();

            this.classList.add('product-card');

            this.dataset.ready = "static" in this.dataset;

            if (this.dataset.ready === 'false') {

                window.theme.product.loadProduct(this.dataset.handle).then(product => {

                    this.product = product;

                    this.render(product);
                    this.initEvents();
                });
            } else {
                this.initEvents();
            }
        }

        /**
         * Init component events
         *
         * @param {object} product Product data.
         * @returns {undefined}
         */
        initEvents() {
            const swatches = this.querySelector('component-swatches');

            swatches?.addEventListener('swatch-change', event => {
                this.changeProductImage(event.detail.variant)
            });
        }

        changeProductImage(variant) {
            if(!variant.featured_image) return;

            this.querySelectorAll('picture img').forEach(img => {
                img.src = variant.featured_image.src;
            });
            this.querySelectorAll('picture source').forEach(img => {
                img.srcset = variant.featured_image.src;
            });
        }

        /**
         * Render component in the DOM
         *
         * @param {object} product Product data.
         * @returns {undefined}
         */
        render(product) {


            let html = this.template();

            html = html.replaceAll(/{{productHandle}}/g, product.handle);
            html = html.replaceAll(/{{productTitle}}/g, product.title);

            let extension = "";
            let productImage = "";

            if(product.featured_image) {
                extension = /[^.]+$/.exec(product.featured_image);
                const productImageUrl = (product.featured_image).replace('.' + extension, '_' + '600x600_crop_top.' + extension);
                productImage = `<img src="${productImageUrl}"/>`
            }
            else {
                productImage = '<svg class="w-full object-contain h-full bg-no-image bg-neutral-100 rounded-xl" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5"><path d="M324.5 212.7H203c-1.6 0-2.8 1.3-2.8 2.8V308c0 1.6 1.3 2.8 2.8 2.8h121.6c1.6 0 2.8-1.3 2.8-2.8v-92.5c0-1.6-1.3-2.8-2.9-2.8zm1.1 95.3c0 .6-.5 1.1-1.1 1.1H203c-.6 0-1.1-.5-1.1-1.1v-92.5c0-.6.5-1.1 1.1-1.1h121.6c.6 0 1.1.5 1.1 1.1V308z"></path><path d="M210.4 299.5H240v.1s.1 0 .2-.1h75.2v-76.2h-105v76.2zm1.8-7.2l20-20c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l1.5 1.5 16.8 16.8c-12.9 3.3-20.7 6.3-22.8 7.2h-27.7v-5.5zm101.5-10.1c-20.1 1.7-36.7 4.8-49.1 7.9l-16.9-16.9 26.3-26.3c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l27.5 27.5v7.8zm-68.9 15.5c9.7-3.5 33.9-10.9 68.9-13.8v13.8h-68.9zm68.9-72.7v46.8l-26.2-26.2c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-26.3 26.3-.9-.9c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-18.8 18.8V225h101.4z"></path><path d="M232.8 254c4.6 0 8.3-3.7 8.3-8.3s-3.7-8.3-8.3-8.3-8.3 3.7-8.3 8.3 3.7 8.3 8.3 8.3zm0-14.9c3.6 0 6.6 2.9 6.6 6.6s-2.9 6.6-6.6 6.6-6.6-2.9-6.6-6.6 3-6.6 6.6-6.6z"></path></svg>';
            }

            html = html.replaceAll(/{{productImage}}/g, productImage);


            html = html.replaceAll(/{{productUrl}}/g, product.url);
            html = html.replaceAll(/{{productId}}/g, product.id);
            html = html.replaceAll(/{{variantId}}/g, product.variants[0].id);
            html = html.replaceAll(/{{productLabel}}/g, this.addLabel(product,this.dataset.sale,this.dataset.productBadgeJumpLine));
            html = html.replaceAll(/{{productBadge}}/g, this.addBadge(product,
                                                                        this.dataset.productBadgeBestSellerValueTag,
                                                                        this.dataset.productBadgeOnSaleValueTag,
                                                                        this.dataset.productBadgeNewValueTag,
                                                                        this.dataset.productBadgeJumpLine
                                                                    ));

            this.innerHTML = html;

            this.dataset.ready =  true;
        }

        /**
         * Get template
         *
         * @returns {string} Component HTML template.
         */
        template() {

            if (window.templateProductCard) {

                return window.templateProductCard;

            } else {

                return `
                    <div>
                        {{ productImage }}
                        <a href="{{productUrl}}">{{productTitle}}</a>
                        <product-price data-handle="{{productHandle}}"></product-price>
                    </div>
                `;

            }
        }


        /**
         * Add Badge
         *
         * @returns {string} Component HTML template.
         */
        addBadge(product,productBadgeBestSellerValueTag,productBadgeOnSaleValueTag,productBadgeNewValueTag,jump_line){
            let html = '';

            product.tags.forEach(tag => {
                tag = tag.toLowerCase();

                if(tag.includes("badge:")){
                    let array_Tags = tag.split(':');
                    let last = array_Tags[1];

                    if(last == productBadgeBestSellerValueTag){
                       html += `<div class="product-badge product-badge__best-seller font-bold text-xs leading-3 tracking-[-1%] inline-block mt-1">${last}</div>`;
                       if(jump_line){html += `<br>`;}
                    }else if(last == productBadgeOnSaleValueTag){
                        html += `<div class="product-badge product-badge__on-sale font-bold text-xs leading-3 tracking-[-1%] inline-block mt-1">${last}</div>`;
                        if(jump_line){html += `<br>`;}
                    }else if(last == productBadgeNewValueTag){
                        html += `<div class="product-badge product-badge__new font-bold text-xs leading-3 tracking-[-1%] inline-block mt-1">${last}</div>`;
                        if(jump_line){html += `<br>`;}
                    }else{
                        html += `<div class="product-badge product-badge__default font-bold text-xs leading-3 tracking-[-1%] inline-block mt-1">${last}</div>`;
                        if(jump_line){html += `<br>`;}
                    }
                }
            });

            return html;
        }



        /**
         * Add Label
         *
         * @returns {string} Component HTML template.
         */
        addLabel(product,sale,jump_line) {

            let html = '';

            if (product.available){
                product.tags.forEach(tag => {

                    if(tag.includes("label:")){
                        let array_Tags = tag.split(':');
                        html += `<div class="text-xs font-bold px-2 py-1 tx-width bg-blue-100 inline-block product-label__percentage">${array_Tags[1]}</div>`;
                        if(jump_line){html += `<br>`;}
                    }
                });

            }

            if(sale){
                if(sale == "percentage"){

                    if (product.price_varies) {

                        let max_percentage = 0;

                        product.variants.forEach(variant => {

                            if(variant.compare_at_price > variant.price && variant.available){

                                let sale_difference = (variant.compare_at_price - variant.price) / 100;
                                let variant_price = variant.compare_at_price / 100;
                                let sale_percentage = Math.trunc((sale_difference * 100) / variant_price);

                                if (sale_percentage >  max_percentage){
                                    max_percentage = sale_percentage;
                                }
                            }
                        });

                        if (max_percentage != 0){
                            max_percentage = '-' + max_percentage + '%';
                            html += `<div class="text-xs font-bold px-2 py-1 tx-width bg-blue-100 inline-block  product-label__percentage">${max_percentage}</div>`;

                            if(jump_line){html += `<br>`;}
                        }


                    }else{
                        if(product.compare_at_price > product.price && product.available){

                            let sale_difference = product.compare_at_price - product.price / 100;
                            let product_price = product.compare_at_price / 100;
                            let sale_percentage = Math.trunc((sale_difference * 100) / product_price);
                            sale_percentage = '-' + sale_percentage + '%';

                            html += `<div class="product-label__percentage text-xs font-bold px-2 py-1 tx-width bg-blue-100 inline-block">${sale_percentage}</div>`;
                            if(jump_line){html += `<br>`;}
                        }
                    }

                }else{
                    html += `<div class="product-label__percentage text-xs font-bold px-2 py-1 bg-blue-100 font-body inline-block">${sale}</div>`;
                    if (jump_line){html += `<br>`;}
                }

            }

            return html;
        }


    }

    customElements.define(customElements.component, productCard);
}
